module.exports = __webpack_public_path__ + "img/garden-2.bf30266a.jpeg";